module.exports = __webpack_public_path__ + "static/RevLogo-532c31229591381c6b34d78634d29be6.png";